export const paths = {
  ROOT_ROUTE: '/',
  MEDIA_ROUTE: '/media/',
  CHANNELS_ROUTE: '/channels/',
  PRIVACY_ROUTE: '/privacy',
  IMPRINT_ROUTE: '/imprint',
};
